document.addEventListener('DOMContentLoaded', () => {
    const updateCartIcon = async () => {
        try {
            const response = await fetch('/cart.js');
            const cart = await response.json();
            const cartItemCount = cart.item_count;

            const cartIconBubble = document.getElementById('cart-icon-bubble');
            let cartCountBubble = cartIconBubble.querySelector('.cart-count-bubble');

            if (cartItemCount === 0) {
                if (cartCountBubble) cartCountBubble.remove();
            } else {
                if (!cartCountBubble) {
                    cartCountBubble = document.createElement('div');
                    cartCountBubble.className = 'cart-count-bubble';
                    cartIconBubble.appendChild(cartCountBubble);
                }
                cartCountBubble.innerHTML = `
                    <span aria-hidden="true">${cartItemCount}</span>
                    <span class="visually-hidden">Cart contains ${cartItemCount} items</span>
                `;
            }
        } catch (error) {
            console.error('Error updating cart icon:', error);
        }
    };

    const updateCartSection = async () => {
        try {
            const response = await fetch('/cart?section_id=tso-cart-drawer');
            const html = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newContent = doc.querySelector('#CartDrawer');
            const cartDrawer = document.getElementById('CartDrawer');

            if (newContent && cartDrawer) {
                cartDrawer.innerHTML = newContent.innerHTML;
                document.dispatchEvent(new Event('cartDrawerUpdated'));
            }
        } catch (error) {
            console.error('Error updating cart section:', error);
        }
    };

    const showMinicartMessage = (type) => {
        const message = document.querySelector(`#CartDrawer .minicart-message.${type}`);
        if (message) {
            message.classList.remove('hidden');
            setTimeout(() => message.classList.add('hidden'), 3000);
        }
    };

    const handleQuantityUpdate = async (button) => {
        const itemId = button.dataset.itemId;
        const quantity = parseInt(document.getElementById(`qinput-${itemId}`).value, 10);

        button.disabled = true;
        button.classList.remove('visible');

        try {
            await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: itemId, quantity }),
            });
            await Promise.all([updateCartSection(), updateCartIcon()]);
            showMinicartMessage('updated');
        } catch (error) {
            console.error('Error updating cart quantity:', error);
        }
    };

    const handleItemRemoval = async (removeLink) => {
        const itemId = removeLink.dataset.itemKey;
        const confirmMessage = removeLink.dataset.confirm;
        if (!confirm(confirmMessage)) return;

        try {
            await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: itemId, quantity: 0 }),
            });
            await Promise.all([updateCartSection(), updateCartIcon()]);
            showMinicartMessage('remove');
        } catch (error) {
            console.error('Error removing cart item:', error);
        }
    };

    // Global event handlers
    document.addEventListener('click', (event) => {
        if (event.target.classList.contains('quantity-button')) {
            handleQuantityUpdate(event.target);
        } else if (event.target.classList.contains('remove')) {
            event.preventDefault();
            handleItemRemoval(event.target);
        } else if (!event.target.classList.contains('cart-item-quantity') && 
                   !event.target.classList.contains('quantity-button')) {
            document.querySelectorAll('.quantity-button.visible').forEach((button) => {
                button.disabled = true;
                button.classList.remove('visible');
            });
        }
    });

    document.addEventListener('focus', (event) => {
        if (event.target.classList.contains('cart-item-quantity')) {
            const input = event.target;
            input.dataset.initialValue = input.value;
            const button = input.nextElementSibling;
            button.disabled = false;
            button.classList.add('visible');
        }
    }, true);

    document.addEventListener('blur', (event) => {
        if (event.target.classList.contains('cart-item-quantity')) {
            const input = event.target;
            const initialValue = input.dataset.initialValue;
            const button = input.nextElementSibling;
            if (input.value === initialValue) {
                button.disabled = true;
                button.classList.remove('visible');
            }
        }
    }, true);

    document.addEventListener('input', (event) => {
        if (event.target.classList.contains('cart-item-quantity')) {
            const input = event.target;
            const initialValue = input.dataset.initialValue;
            const button = input.nextElementSibling;
            if (input.value === initialValue) {
                button.disabled = true;
                button.classList.remove('visible');
            }
        }
    });

    // Initial updates
    updateCartIcon();
    document.addEventListener('cartDrawerUpdated', updateCartIcon);
});
